import { Dispatch } from "redux";
import api from "../../api/api";

import {
    linkGoogleDrive,
    setloading,
    seterror,
    resetlinkGoogleDrive,
} from "../reducers/linkGoogleDriveReducer";

const linkGDrive = (token: string, courseId: number ,type : string) => async (dispatch: Dispatch) => {
    dispatch(setloading(true));

    try {
        const response = await api.post(
            `/auth/google-drive-data-sync/`,
            { course_id: courseId, sync_type: type },
            {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${token}`,
            },
            }
        );

        dispatch(setloading(false));

        if (response.data.status === 200) {
            dispatch(linkGoogleDrive(response?.data?.message));
        }
    } catch (error: any) {
        dispatch(seterror(error?.response?.data?.message));
        dispatch(setloading(false));
    }
};

export { linkGDrive, resetlinkGoogleDrive };